import React from 'react'
import PropTypes from 'prop-types'

import RelatedEntities from '@/component/Primitive/RelatedEntities'

const ArticleLayoutRelatedEntitiesWidget = ({ article }) => {
  if (!article) return null
  return <RelatedEntities article={article} />
}

ArticleLayoutRelatedEntitiesWidget.propTypes = {
  article: PropTypes.object
}

export default ArticleLayoutRelatedEntitiesWidget
